import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const PaginationContainer = styled.div``;

const ArrowBtn = styled.a`
    box-sizing: border-box;
    display: inline-block;
    margin-right: 8px;
    min-width: 40px;
    ${FONTS.Medium};
    text-align: center;
    border: none;
    border-radius: 4px;
    background: 0 0;
    color: #979797;
    cursor: pointer;

    &:hover {
        color: ${COLORS.TextPrimary};
    }
`;

export const Prev = styled(ArrowBtn)`
    &::before {
        content: "\\e654";
        font-family: "icomoon";
        position: relative;
        left: 17px;
        font-size: 28px;
        margin-right: 25px;
    }
`;

export const Next = styled(ArrowBtn)`
    &::before {
        content: "\\e655";
        font-family: "icomoon";
        position: relative;
        left: 17px;
        font-size: 28px;
        margin-right: 25px;
    }
`;

export const BtnWrap = styled.div``;

export const Btn = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f7f7f8;
    border: 1px solid #ebebeb;
    color: inherit;
    ${FONTS.MediumS};
    border-radius: 4px;
    margin-right: 8px;
    min-width: 40px;
    height: 40px;
    cursor: pointer;

    &:hover {
        color: #ff2323;
    }

    &:last-child {
        margin-right: 0;
    }

    ${props => props.isActive
    ? `
        background: #fff;
        border-color: #979797;
    `
    : ''}
`;
